import {useDebugValue} from 'react';

import {noop} from '../../../utils/noop';

import {useEvents} from './useEvents';

const defaultGuestsEvents = {
    onSettingsChange: noop,
    onCurrentValuesChange: noop,
    onLatestValuesChange: noop,
    onChange: noop,
    onClear: noop,
    onClose: noop,
    onExit: noop,
    onOpen: noop
};

function useGuestsEvents(props) {
    const {
        guestsEvents: propsGuestsEvents
    } = props;

    const {
        events: guestsEvents
    } = useEvents(defaultGuestsEvents, propsGuestsEvents);

    const result = {
        guestsEvents
    };

    useDebugValue(result);

    return result;
}

export {useGuestsEvents};
